import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { MainLayout } from '@components/layout/MainLayout';
import { ProtectedRoute } from '@components/ProtectedRoute';
import { NotificationToast } from '@components/NotificationToast';
import Dashboard from '@pages/Dashboard';
import Applications from '@pages/Applications';
import ApplicationDetail from '@pages/ApplicationDetail';
import Customers from '@pages/Customers';
import CustomerDetail from '@pages/CustomerDetail';
import InstallDetail from '@pages/InstallDetail';
import Licenses from '@pages/Licenses';
import ClaimCodes from '@pages/ClaimCodes';
import ClaimCodeDetail from '@pages/ClaimCodeDetail';
import Invoices from '@pages/Invoices';
import Analytics from '@pages/Analytics';
import AuditLog from '@pages/AuditLog';
import Login from '@pages/Login';
import AccessDenied from '@pages/AccessDenied';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <NotificationToast />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/access-denied" element={<AccessDenied />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/applications" element={<Applications />} />
                    <Route path="/applications/:appId" element={<ApplicationDetail />} />
                    <Route path="/customers" element={<Customers />} />
                    <Route path="/customers/:customerId" element={<CustomerDetail />} />
                    <Route path="/installs/:installId" element={<InstallDetail />} />
                    <Route path="/licenses" element={<Licenses />} />
                    <Route path="/claim-codes" element={<ClaimCodes />} />
                    <Route path="/claim-codes/:code" element={<ClaimCodeDetail />} />
                    <Route path="/invoices" element={<Invoices />} />
                    <Route path="/analytics" element={<Analytics />} />
                    <Route path="/audit-log" element={<AuditLog />} />
                  </Routes>
                </MainLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </QueryClientProvider>
    </Router>
  );
}

export default App;
